import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-field-label',
  standalone: true,
  templateUrl: './form-field-label.component.html',
  styleUrls: ['./form-field-label.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldLabelComponent {
  @Input() text = '';
  @Input() forId = '';
  @Input() required = false;
}
